import { useMemo } from "react";
import {
  useGetProjectTaskQuery,
  useGetProjectTasksQuery,
} from "./projectTaskEndpoints";
import { ProjectTask } from "../../entities/projectTask";

export function useProjectTask(projectTaskID: number | undefined) {
  const projectTaskQuery = useGetProjectTaskQuery(projectTaskID ?? 0, {
    skip: (projectTaskID ?? 0) <= 0,
  });
  const projectTaskEntity = projectTaskQuery.data;

  return useMemo(() => {
    const ret: typeof projectTaskQuery & {
      projectTask?: ProjectTask | undefined;
    } = {
      ...projectTaskQuery,
    };
    if (projectTaskEntity) ret.projectTask = new ProjectTask(projectTaskEntity);
    return ret;
  }, [projectTaskEntity]);
}

export function useProjectTasks(projectID?: number) {
  const projectTaskQuery = useGetProjectTasksQuery(projectID, {
    skip: !projectID,
  });
  const projectTaskEntitiesMap = projectTaskQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof projectTaskQuery & {
      projectTasks?: ProjectTask[];
      projectTasksMap?: { [id: number]: ProjectTask };
    } = {
      ...projectTaskQuery,
      projectTasks: [],
      projectTasksMap: {},
    };
    if (projectTaskEntitiesMap) {
      const projectTasks: ProjectTask[] = [];
      const projectTasksMap: { [id: number]: ProjectTask } = {};

      for (const key in projectTaskEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(projectTaskEntitiesMap, key)) {
          const c = projectTaskEntitiesMap[key];
          const projectTask = new ProjectTask(c);
          projectTasks.push(projectTask);
          projectTasksMap[projectTask.id] = projectTask;
        }
      }
      ret.projectTasks = projectTasks;
      ret.projectTasksMap = projectTasksMap;
    }

    return ret;
  }, [projectTaskEntitiesMap]);
}
